const rellax = require('../../../components/rellax/rellax.script');
const AOS_animation = require('../../../components/AOS-animation/AOS-animation.script');
export async function load() {
  try {
    await rellax.start('.rellax');
    await AOS_animation.start();
    return true
  } catch (err) {
    console.log('err', err)
    return err
  }
}
